<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,7C7.45,7,7,7.45,7,8C7,8.55,7.45,9,8,9C8.55,9,9,8.55,9,8C9,7.45,8.55,7,8,7C8,7,8,7,8,7ZM8,11C7.45,11,7,11.45,7,12C7,12.55,7.45,13,8,13C8.55,13,9,12.55,9,12C9,11.45,8.55,11,8,11C8,11,8,11,8,11ZM8,3C7.45,3,7,3.45,7,4C7,4.55,7.45,5,8,5C8.55,5,9,4.55,9,4C9,3.45,8.55,3,8,3C8,3,8,3,8,3ZM14,6C13.07,6,12.29,6.64,12.07,7.5C12.07,7.5,11,7.5,11,7.5C11,7.5,11,3,11,3C11,1.34,9.66,0,8,0C6.34,0,5,1.34,5,3C5,3,5,7.5,5,7.5C5,7.5,3.93,7.5,3.93,7.5C3.71,6.64,2.93,6,2,6C0.9,6,0,6.9,0,8C0,9.1,0.9,10,2,10C2.93,10,3.71,9.36,3.93,8.5C3.93,8.5,5,8.5,5,8.5C5,8.5,5,13,5,13C5,14.66,6.34,16,8,16C9.66,16,11,14.66,11,13C11,13,11,8.5,11,8.5C11,8.5,12.07,8.5,12.07,8.5C12.29,9.36,13.07,10,14,10C15.1,10,16,9.1,16,8C16,6.9,15.1,6,14,6C14,6,14,6,14,6ZM10,13C10,14.1,9.1,15,8,15C6.9,15,6,14.1,6,13C6,13,6,3,6,3C6,1.9,6.9,1,8,1C9.1,1,10,1.9,10,3C10,3,10,13,10,13C10,13,10,13,10,13Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'MergeLinks',
} as DefineComponent
</script>
